// extracted by mini-css-extract-plugin
module.exports = {"arrow-container":"styles__arrow-container___1IOmm","visible":"styles__visible___weNx5","button":"styles__button___3w-1A","icon":"styles__icon___3pxbZ"};